// Íconos SVG en línea (sin dependencia externa). Decorativos: aria-hidden.
import type { SVGProps } from 'react';
import type { WorkType } from '../domain/orders.ts';

function Svg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    />
  );
}

export const WrenchIcon = () => (
  <Svg>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </Svg>
);

export const OrdersIcon = () => (
  <Svg>
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" />
    <path d="M9 12h6M9 16h4" />
  </Svg>
);

export const TeamIcon = () => (
  <Svg>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </Svg>
);

export const ClientsIcon = () => (
  <Svg>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M8 2v2M16 2v2" />
    <circle cx="12" cy="11" r="3" />
    <path d="M7 22v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1" />
  </Svg>
);

export const AccountIcon = () => (
  <Svg>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </Svg>
);

export const LogoutIcon = () => (
  <Svg>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
  </Svg>
);

export const BellIcon = () => (
  <Svg>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  </Svg>
);

export const SearchIcon = () => (
  <Svg>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Svg>
);

export const PlusIcon = () => (
  <Svg>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);

export const RouteIcon = () => (
  <Svg>
    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
    <path d="M15 18H9M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 8.38A1 1 0 0 0 17.52 8H14" />
    <circle cx="17" cy="18" r="2" />
    <circle cx="7" cy="18" r="2" />
  </Svg>
);

export const PackageIcon = () => (
  <Svg>
    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
    <path d="m3.3 7 8.7 5 8.7-5M12 22V12" />
  </Svg>
);

export const ClockIcon = () => (
  <Svg>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Svg>
);

/** Caja con lupa: órdenes esperando que lleguen los repuestos. */
export const PackageSearchIcon = () => (
  <Svg>
    <path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14" />
    <path d="M16.5 9.4 7.55 4.24M3.29 7 12 12l8.71-5M12 22V12" />
    <circle cx="18.5" cy="15.5" r="2.5" />
    <path d="M20.27 17.27 22 19" />
  </Svg>
);

/** Caja con check: repuestos ya disponibles. */
export const PackageCheckIcon = () => (
  <Svg>
    <path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14" />
    <path d="m7.5 4.27 9 5.15M3.29 7 12 12l8.71-5M12 22V12M16 17l2 2 4-4" />
  </Svg>
);

export const CheckCircleIcon = () => (
  <Svg>
    <circle cx="12" cy="12" r="9" />
    <path d="m8.5 12 2.5 2.5 4.5-5" />
  </Svg>
);

/** Devolver (orden devuelta al técnico con observaciones). */
export const UndoIcon = () => (
  <Svg>
    <path d="M9 14 4 9l5-5" />
    <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />
  </Svg>
);

export const ActivityIcon = () => (
  <Svg>
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </Svg>
);

export const CheckAllIcon = () => (
  <Svg>
    <path d="M18 6 7 17l-5-5M22 10l-7.5 7.5L13 16" />
  </Svg>
);

export const ChevronLeftIcon = () => (
  <Svg>
    <path d="m15 18-6-6 6-6" />
  </Svg>
);

export const ChevronRightIcon = () => (
  <Svg>
    <path d="m9 18 6-6-6-6" />
  </Svg>
);

export const ChevronDownIcon = () => (
  <Svg>
    <path d="m6 9 6 6 6-6" />
  </Svg>
);

export const CheckIcon = () => (
  <Svg>
    <path d="M20 6 9 17l-5-5" />
  </Svg>
);

export const CalendarIcon = () => (
  <Svg>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </Svg>
);

export const ShieldCheckIcon = () => (
  <Svg>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="m9 12 2 2 4-4" />
  </Svg>
);

export const ShieldOffIcon = () => (
  <Svg>
    <path d="M19.7 14a6.9 6.9 0 0 0 .3-2V5l-8-3-3.2 1.2M4.7 4.7 4 5v7c0 6 8 10 8 10a20.3 20.3 0 0 0 5.6-4.4" />
    <path d="m2 2 20 20" />
  </Svg>
);

/** Ícono del Tipo Garantía: Garantía, Instalación o Sin garantía. */
export function WorkTypeIcon({ type }: { type: WorkType }) {
  if (type === 'installation') return <WrenchIcon />;
  return type === 'no_warranty' ? <ShieldOffIcon /> : <ShieldCheckIcon />;
}

/** Portapapeles con lápiz: actualizar la orden (asistente de diagnóstico). */
export const ClipboardEditIcon = () => (
  <Svg>
    <rect x="8" y="2" width="8" height="4" rx="1" />
    <path d="M10.5 22H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v3" />
    <path d="M8 12h4M8 16h2" />
    <path d="M20.4 13.6a1.4 1.4 0 0 0-2-2l-5 5-.7 2.7 2.7-.7z" />
  </Svg>
);

export const PencilIcon = () => (
  <Svg>
    <path d="M17 3a2.85 2.85 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    <path d="m15 5 4 4" />
  </Svg>
);

/** Candado: cerrar la orden de forma definitiva. */
export const LockIcon = () => (
  <Svg>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </Svg>
);

export const CopyIcon = () => (
  <Svg>
    <rect x="8" y="8" width="14" height="14" rx="2" />
    <path d="M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2" />
  </Svg>
);

/** Prohibido: anular la orden. */
export const BanIcon = () => (
  <Svg>
    <circle cx="12" cy="12" r="9" />
    <path d="m5.6 5.6 12.8 12.8" />
  </Svg>
);

export const PaperclipIcon = () => (
  <Svg>
    <path d="m21.4 11.1-9.2 9.2a6 6 0 0 1-8.5-8.5l8.6-8.6a4 4 0 0 1 5.7 5.7l-8.6 8.6a2 2 0 0 1-2.8-2.8l8.5-8.5" />
  </Svg>
);

/** Cuadrícula: lista de órdenes en tarjetas. */
export const LayoutGridIcon = () => (
  <Svg>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </Svg>
);

/** Tabla: lista de órdenes en filas y columnas. */
export const TableIcon = () => (
  <Svg>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M3 15h18M9 9v12" />
  </Svg>
);

export const ChevronsLeftIcon = () => (
  <Svg>
    <path d="m11 17-5-5 5-5M18 17l-5-5 5-5" />
  </Svg>
);
